import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';

import CodeStorage from '../utils/code-storage.js'

Vue.use(Vuex)

function loadOptions () {
  let autoRender = CodeStorage.fetch('autoRender')
  if (autoRender === null || autoRender === undefined) {
    autoRender = true
    CodeStorage.save({ autoRender })
  } else {
    autoRender = (autoRender === 'true')
  }
  return { autoRender }
}

const state = {
  options: {
    autoRender: loadOptions().autoRender,
    authUser:CodeStorage.getJWT(),
    userLogin:CodeStorage.getUserLogin(),
    isLogin:CodeStorage.isLogin(),
  },
  controlValue: {
    showLayout: false,
    floatLayout: false,
    enableDownload: true,
    previewModal: true,
    paginateElementsByHeight: 3508,
    manualPagination: false,
    filename: 'Kichwa-code-certificate',
    pdfQuality: 2,
    pdfFormat: 'a4',
    pdfOrientation: 'portrait',
    pdfContentWidth: '1024px'
  }
}

const getters = {
  autoRender ({ options }) {
    return options.autoRender
  },
  getJWT ({ options }) {
    return options.authUser;
  },
  userLogin ({ options }) {
  return options.userLogin;
  },
  isLogin ({ options }) {
    return options.isLogin;
  },
  getField
}



const mutations = {
  setAutoRender ({ options }, autoRender) {
    options.autoRender = autoRender
    CodeStorage.save({ autoRender })
  },
  setJWT ({ options }, jwt) {
    options.authUser = jwt
    CodeStorage.saveJWT(jwt);
  },
  setUser ({ options }, user) {
    options.userLogin = user
    CodeStorage.saveJWT(user);
  },
  setLogin ({ options }, status) {
    options.isLogin=status
    CodeStorage.saveLogin(status);
  },
  updateField


}

const actions = {
  setAutoRender ({ commit }, autoRender) {
    commit('setAutoRender', autoRender)
  },
  setJWT ({ commit }, jwt) {
    commit('setJWT', jwt)
  },
  setUser ({ commit }, user) {
    commit('setUser', user)
  },
  setLogin ({ commit }, status) {
    commit('setLogin', status)
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
